import * as React from "react";
import { UserGoalView } from "@curefit/gmf-common";
import {AppPlaceholders} from "../../utils/AppConstants";
import {isEmpty as _isEmpty} from "lodash"
import TextInput from "../TextInput";

/**
 * Created by aditya on 28/06/18.
 */

export interface DietThemeItemEditorProps {
    item: UserGoalView,
    onDataChange: (update: UserGoalView) => any
}

class OtherGoalItemEditor extends React.Component<DietThemeItemEditorProps> {
    constructor(props: DietThemeItemEditorProps) {
        super(props)
    }

    onGoalNameChange = (evt: any) => {
        let updatedGoal = { ...this.props.item };
        updatedGoal.goalName = evt.target.value;
        this.props.onDataChange(updatedGoal);
    }

    render() {
        let goalName = !_isEmpty(this.props.item) && !_isEmpty(this.props.item.goalName) ? this.props.item.goalName : "";
        let isCancelled = !_isEmpty(this.props.item.editInfo) && this.props.item.editInfo.nextStatus === "CANCELLED";
        let isEditable = _isEmpty(this.props.item._id);
        return (
            <div className={`other-health-target-item-editor ${!isEditable ? "read-only" : ""} ${isCancelled ? "cancelled" : ""}`} >
                <div className="diet-theme-item-editor-name">
                    <TextInput disabled={!isEditable} name={"diet-theme-name"} value={goalName} placeholder={AppPlaceholders.HEALTH_TARGET_OTHER_GOAL} onChange={this.onGoalNameChange} />
                </div>
            </div>
        )
    }
}

export default OtherGoalItemEditor;